import { render, staticRenderFns } from "./KBDropdown.vue?vue&type=template&id=6ea4ea90&scoped=true&"
import script from "./KBDropdown.vue?vue&type=script&lang=ts&"
export * from "./KBDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./KBDropdown.vue?vue&type=style&index=0&id=6ea4ea90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea4ea90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
